require('./loanSettlementsRow.scss');
const PropTypes = require('prop-types');
//@vendor
const React = require('react');
const classNames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
//@components
const { LabelDate } = require('commonsComponents/labelDate');
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

class LoanSettlementsRow extends React.Component {
    constructor(props) {
        super(props);

        this.handleRowClick = this.handleRowClick.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleRowClick() {
        this.props.onRowClick(this.props.id);
    }

    render() {
        const { immTransaction, id, isExpanded } = this.props;
        const expandButtonId = `btn_loanSettlementsRow_expand_${id}`;
        const expandIconClass = classNames({
            'icon-accordion-abrir': !isExpanded,
            'icon-accordion-cerrar': isExpanded,
        });
        const plainAmountDebitObject = getPlainAmountObject(immTransaction.get('debitAmount'));
        const plainAmountCreditObject = getPlainAmountObject(immTransaction.get('creditAmount'));
        const language = getLanguage();

        return (
            <OKTableRow id={id} isExpanded={isExpanded}>
                <OKTableCell className="loan-settlements-row__cell-expand">
                    <button id={expandButtonId} className="loan-settlements-row__expand-button" onClick={this.handleRowClick}>
                        <i className={expandIconClass} />
                    </button>
                </OKTableCell>
                <OKTableCell>
                    <LabelDate
                        date={immTransaction.get('fromDate')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    <LabelDate
                        date={immTransaction.get('toDate')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    <OneLineSymbolAmount
                        amountObject={plainAmountDebitObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountDebitObject, true)} />
                </OKTableCell>
                <OKTableCell>
                    <OneLineSymbolAmount
                        amountObject={plainAmountCreditObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountCreditObject, true)} />
                </OKTableCell>
            </OKTableRow>
        );
    }
}

LoanSettlementsRow.propTypes = {
    immTransaction: PropTypes.object,
    id: PropTypes.string,
    onRowClick: PropTypes.func,
    isExpanded: PropTypes.bool,
};

LoanSettlementsRow.defaultProps = {
    className: '',
    onRowClick: function () { }
};

module.exports = LoanSettlementsRow;
